import React, { useState, useEffect } from "react";
import { Button, Tag, Callout } from "@blueprintjs/core";
import Raw from "./Raw";
import api from "../../common/lib/api";
import { ApiWrapped } from "./ApiWrapped";

export function savePanic(id, session) {
  localStorage["PocketSecurePanic-" + id] = JSON.stringify({ session, id });
}

export function readPanic(id) {
  const data = localStorage["PocketSecurePanic-" + id];
  if (data) {
    return JSON.parse(data).session;
  }
}

export function deletePanic(id) {
  delete localStorage["PocketSecurePanic-" + id];
}

export function MobilePanicActions({ token, node, device }) {
  const panicSessionId = readPanic(node.deviceNodeUuid);
  const [state, setState] = useState({
    hasPanic: Boolean(panicSessionId),
    panicSessionId: panicSessionId,
  });
  const [message, setMessage] = useState({});
  useEffect(() => {
    let timeout;
    if (state.hasPanic) {
      if (navigator.geolocation) {
        function update() {
          navigator.geolocation.getCurrentPosition(
            async (position) => {
              try {
                await api.patch(
                  `/mobile-panics/${node.deviceNodeUuid}/sessions/${state.panicSessionId}`,
                  {
                    lat: position.coords.latitude,
                    lng: position.coords.longitude,
                    accuracy: position.coords.accuracy,
                  }
                );
                timeout = setTimeout(update, 1000);
              } catch (e) {
                setMessage({
                  message: e.message,
                  messageIntent: "danger",
                });
              }
            },
            (e) => {
              setMessage({
                message: e.message,
                messageIntent: "danger",
              });
            }
          );
        }
        update();
      } else {
        setMessage({
          message: "Geolocation is not supported by this browser.",
          messageIntent: "danger",
        });
      }
      return () => {
        if (timeout) {
          clearTimeout(timeout);
        }
      };
    }
  }, [state, setState, node.deviceNodeUuid]);
  return (
    <>
      <p>
        <strong>Action:</strong>{" "}
        <Button
          intent="primary"
          disabled={state.hasPanic}
          onClick={async () => {
            // make panic session
            const { data: session } = await api.post(
              `/mobile-panics/${node.deviceNodeUuid}/sessions`
            );
            setState({
              hasPanic: true,
              panicSessionId: session.panicSessionId,
            });
            setMessage({
              message: "Panic started",
              messageIntent: "success",
            });
            savePanic(node.deviceNodeUuid, session.panicSessionId);
          }}
        >
          Start Panic
        </Button>
        <Button
          intent="primary"
          disabled={!state.hasPanic}
          onClick={async () => {
            deletePanic(node.deviceNodeUuid);
            await api.post(
              `/mobile-panics/${node.deviceNodeUuid}/sessions/${state.panicSessionId}/action`,
              {
                action: "cancel",
              }
            );
            setMessage({
              message: "Panic cancelled",
              messageIntent: "success",
            });
            setState({
              hasPanic: false,
            });
          }}
        >
          Cancel Panic
        </Button>
      </p>
      {message.message && message.messageIntent && (
        <Callout intent={message.messageIntent}>{message.message}</Callout>
      )}
      <ApiWrapped
        token={token}
        endpoint={`/mobile-panics/${node.deviceNodeUuid}/users`}
        renderCallback={function AccountInfo({ state: users }) {
          return (
            <p>
              <Raw json={users.data} />
              <strong>Receiving Users:</strong>{" "}
              {users.data.map((user, index) => (
                <Tag
                  key={index}
                  style={{
                    margin: ".25em",
                  }}
                  minimal
                  intent={
                    user.notificationText === "Notification On"
                      ? "success"
                      : "warning"
                  }
                  rightIcon={
                    user.notificationText === "Notification On"
                      ? "tick"
                      : "cross"
                  }
                >
                  {user.name}
                </Tag>
              ))}
            </p>
          );
        }}
      />
    </>
  );
}
